import api from '@/api'
import TicketSearchRequest from '@/model/ticket/TicketSearchRequest'
import TicketRequest from '@/model/ticket/TicketRequest'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAllTickets(actions, { filter, pagination, sort }) {
      return api.base()
        .post('/tickets/get/all',
          TicketSearchRequest({ ...(filter || {}), pagination, sort })
        )
        .then(response => ({
          data: response.data.data,
          pagination: { page: response.data.metadata.page, pages: response.data.metadata.pages, total: response.data.metadata.total },
          sort: response.data.metadata.sort,
        }))
    },
    getTicketById(actions, id) {
      return api.base()
        .get('/tickets/id/' + id)
        .then(response => response.data.data)
    },
    createTicket(actions, { ticket, files }) {
      if (files && files.length > 0) {
        let formData = new FormData()
        formData.append('ticket', new Blob([JSON.stringify(TicketRequest(ticket))], { type: 'application/json' }))
        files.forEach(file => {
          formData.append('files', file)
        })
        return api.base()
          .post('/tickets/add', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => response.data.data)
      } else {
        return api.base()
          .post('/tickets/add/json', TicketRequest(ticket))
          .then(response => response.data.data)
      }
    },
    updateTicket(actions, { id, ticket }) {
      return api.base()
        .post('/tickets/update/' + id, TicketRequest(ticket))
        .then(response => response.data.data)
    },
    updateTicketStatus(actions, { id, status }) {
      return api.base()
        .post('/tickets/update/status/' + id + '?status=' + status)
        .then(response => response.data.data)
    },
    addComment(actions, { id, message, files }) {
      if (files && files.length > 0) {
        let formData = new FormData()
        formData.append('comment', new Blob([JSON.stringify({ message })], { type: 'application/json' }))
        files.forEach(file => {
          formData.append('files', file)
        })
        return api.base()
          .post('/tickets/comment/' + id, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => response.data.data)
      } else {
        return api.base()
          .post('/tickets/comment/' + id + '/json', { message })
          .then(response => response.data.data)
      }
    },
    downloadAttachment(actions, { ticketId, fileName }) {
      return api.base()
        .get('/tickets/file/' + ticketId + '/' + fileName, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
        })
    },
  },
}
